module.exports = __webpack_public_path__ + "ddaf37c2281e6a9a563586376b688575.pdf";